"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionList = exports.defaultParams = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var moment = require("moment");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var ColumnFilter_1 = require("components/ColumnFilter");
var components_1 = require("components");
var sok_ui_1 = require("@caddigital/sok-ui");
var QuestionActions = require("@caddigital/sok-reducers/lib/actions/bid/questions");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var search_1 = require("utils/search");
var avatars_1 = require("components/Avatar/avatars");
var SortButton = sok_ui_1.Table.SortButton;
var headers = ['createdAt', 'answer', 'answeredAt', 'question'];
exports.defaultParams = {
    orderBy: 'question',
    order: 'asc'
};
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        list: state.bid.questions,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (bid) { return dispatch(QuestionActions.fetchRequest(bid)); },
    select: function (questions) {
        return dispatch(QuestionActions.select(questions));
    },
    unselect: function (questions) {
        return dispatch(QuestionActions.unselect(questions));
    },
    toggleAnswerQuestionModal: function (questions) {
        if (questions === void 0) { questions = []; }
        return dispatch(QuestionActions.toggleAnswerQuestion(questions));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
function getFilteredData(list, seachString, filters) {
    if (seachString === void 0) { seachString = ''; }
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (seachString.length > 0) {
            return list.filter(function (item) {
                return item.question.toLowerCase().includes(seachString.toLowerCase()) ||
                    (item.answer || '').toLowerCase().includes(seachString.toLowerCase());
            });
        }
        return __spreadArray([], list, true);
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            switch (key) {
                case 'filter': {
                    if ((filters[key] === 'answered' && item.answer === null) ||
                        (filters[key] === 'unanswered' && item.answer !== null)) {
                        return result;
                    }
                    break;
                }
                case 'answeredAt':
                case 'createdAt': {
                    var searchValue = filters[key];
                    var startTime = moment(searchValue, 'L').startOf('day');
                    var endTime = moment(searchValue, 'L').endOf('day');
                    var sended = moment(item[key] || 0);
                    if (!sended.isBetween(startTime, endTime)) {
                        return result;
                    }
                    break;
                }
                case 'question':
                case 'answer': {
                    var searchValue = filters[key];
                    var value = item[key] || '';
                    if (searchValue &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                default:
                    return result;
            }
        }
        if (item.question.toLowerCase().includes(seachString.toLowerCase()) ||
            (item.answer || '').toLowerCase().includes(seachString.toLowerCase())) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetch(this.props.currentBid);
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        var items = this.props.items;
        if (this.props.queryParams !== prevProps.queryParams ||
            (prevProps.list.list.length === 0 && this.props.list.list.length) ||
            this.props.list.list !== prevProps.list.list ||
            (prevProps.list.listStatus !== 'FETCHED' &&
                this.props.list.listStatus === 'FETCHED')) {
            var _a = this.props.queryParams, order = _a.order, orderBy_1 = _a.orderBy, limit = _a.limit, offset = _a.offset, search = _a.search, filters = __rest(_a, ["order", "orderBy", "limit", "offset", "search"]);
            var orderMultiplier_1 = order === 'asc' ? 1 : -1;
            var list = this.props.list;
            var data = getFilteredData(list.list, search, filters).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'question':
                    case 'answer':
                        return ((a[orderBy_1] || '').localeCompare(b[orderBy_1] || '') *
                            orderMultiplier_1);
                    case 'createdAt':
                    case 'answeredAt':
                        return (moment(a[orderBy_1] || 0).diff(moment(b[orderBy_1] || 0)) *
                            orderMultiplier_1);
                    default:
                        return 0;
                }
            });
            this.props.setTotal(data.length);
            this.props.setItems(data);
        }
        if (items !== prevProps.items) {
            var contentWidth_1 = 0;
            var columns_1 = this.props.list.list.reduce(function (p, item) {
                headers.forEach(function (x) {
                    var dataKey = '__' + x.replace(/-/g, '');
                    switch (x) {
                        case 'createdAt':
                        case 'answeredAt': {
                            if (_this.props.mode === 'portal') {
                                break;
                            }
                            var val = item[x];
                            var text = val ? moment(val).format('L') : '--';
                            var length = (0, text_1.calculateStringLength)(text);
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'question':
                        case 'answer': {
                            var text = item[x] || '--';
                            var length = (0, text_1.calculateStringLength)(text);
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                    }
                });
                return p;
            }, {});
            headers.forEach(function (x) {
                if (!headers.includes(x)) {
                    return;
                }
                else if (_this.props.mode === 'portal' &&
                    (x === 'createAt' || x === 'answeredAt')) {
                    return;
                }
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("bid/questionsAndAnswers/column/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 55;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue < length) {
                    columns_1[dataKey] = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = length;
                }
            });
            // Override styles for dynamic classes
            var style = document.getElementById('BidQuestionsListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'BidQuestionsListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 42;
            Object.keys(columns_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + columns_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
}), recompose_1.pure);
function getHeaderColumn(props, name, identifier) {
    var order = props.queryParams.orderBy === identifier &&
        props.queryParams.order === 'asc'
        ? 'desc'
        : 'asc';
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic bid-question-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }, (0, translation_1.getLocalization)("bid/questionsAndAnswers/column/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.queryParams.orderBy === identifier
                ? (props.queryParams.order || 'name').toLowerCase()
                : null, onChange: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames(props.queryParams[identifier] ? 'active' : '', ' filter'), columnIdentifier: identifier, textInputValue: props.queryParams[identifier]
                ? props.queryParams[identifier] || ''
                : '', inputType: identifier === 'createdAt' ? 'day' : 'text', setColumnFilterString: function (field, value) {
                var params = __assign(__assign({}, props.queryParams), { offset: '0' });
                params[field] = value;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            }, clearColumnFilter: function (field) {
                var params = __assign(__assign({}, props.queryParams), { offset: '0' });
                params[field] = undefined;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } })));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-questions', className: 'no-questions' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("bid/questionsAndAnswers/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("bid/questionsAndAnswers/emptyList/message")))); };
var isAllSelected = function (props) {
    return props.list.listStatus === 'FETCHED' &&
        props.list.selected.length > 0 &&
        props.items.every(function (r) {
            return props.list.selected.findIndex(function (f) { return r.id === f.id; }) > -1;
        });
};
var Header = function (props) {
    var all = isAllSelected(props);
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column first narrow icon" }, props.mode === 'sokopro' && (React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: all ? 'selected' : '', onClick: function () {
                return all
                    ? props.unselect(props.list.list)
                    : props.select(props.list.list);
            } }))),
        getHeaderColumn(props, 'question', 'question'),
        props.mode === 'sokopro' &&
            getHeaderColumn(props, 'createdAt', 'createdAt'),
        getHeaderColumn(props, 'answer', 'answer'),
        props.mode === 'sokopro' &&
            getHeaderColumn(props, 'answeredAt', 'answeredAt'),
        React.createElement("div", { className: "row__column narrow" })));
};
var createRowData = memoize(function (style, isMobile, items, selected, select, unselect, toggleAnswerQuestionModal, mode) { return ({
    style: style,
    isMobile: isMobile,
    items: items,
    selected: selected,
    select: select,
    unselect: unselect,
    toggleAnswerQuestionModal: toggleAnswerQuestionModal,
    mode: mode
}); });
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, items = data.items, selected = data.selected, select = data.select, unselect = data.unselect, toggleAnswerQuestionModal = data.toggleAnswerQuestionModal, mode = data.mode;
    var row = items[index];
    var isSelected = selected.find(function (x) { return x.id === row.id; });
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: 'row__column narrow' }, mode === 'sokopro' && (React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: isSelected ? 'selected' : '', onClick: function () { return (isSelected ? unselect([row]) : select([row])); } }))),
        React.createElement("div", { className: classNames('row__column __question', 'pointer', row.exclude && 'excluded'), onClick: function () { return toggleAnswerQuestionModal([row]); } }, row.question),
        mode === 'sokopro' && (React.createElement("div", { className: 'row__column __createdAt' }, moment(row.createdAt).format('L'))),
        React.createElement("div", { className: classNames('row__column __answer', row.exclude && 'excluded') }, row.answer || '--'),
        mode === 'sokopro' && (React.createElement("div", { className: 'row__column __answeredAt' }, row.answeredAt ? moment(row.answeredAt).format('L') : '--')),
        React.createElement("div", { className: 'row__column narrow' })));
}, function (p, n) {
    return p.data.items === n.data.items &&
        p.data.selected === n.data.selected &&
        p.index === n.index;
});
exports.QuestionList = enhance(function (props) {
    var itemData = createRowData({}, props.isMobile, props.items, props.list.selected, props.select, props.unselect, props.toggleAnswerQuestionModal, props.mode);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'bid-question-and-answer-view-list-container' },
            React.createElement("div", { className: 'sok-list-content bid-question-and-answer-view-list ' +
                    props.list.listStatus.toLowerCase() },
                props.list.listStatus === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(props.currentBid); } }))),
                props.list.listStatus === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.list.listStatus === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemKey: function (index, x) { return "".concat(index, "-").concat(x.items[index].id); }, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
                }))))));
});
